import TextBlastConsent from './TextBlastConsent';

export default TextBlastConsent;
